const prefix = 'quickCycles';

export const FIND_CURRENT = `${prefix}/FIND_CURRENT`;
